var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbsintheIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.793 154.65C138.515 158.3 135.473 161.12 131.813 161.12H115.104C111.421 161.12 108.368 158.266 108.12 154.591L106.055 123.991C105.782 119.949 108.988 116.52 113.039 116.52H134.139C138.214 116.52 141.427 119.987 141.118 124.05L138.793 154.65Z",
    stroke: "white",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 116.51V67.0703C115.72 63.2043 112.586 60.0703 108.72 60.0703H102.56H73.23H67C63.134 60.0703 60 63.2043 60 67.0703V154.12C60 157.986 63.134 161.12 67 161.12H108.57H115.72",
    stroke: "white",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79 44L73.2305 60.0697",
    stroke: "white",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.561 60.0697L97 44.5",
    stroke: "white",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.037 42.2802C105.893 43.8217 104.599 45 103.05 45H73.0154C71.4764 45 70.187 43.8354 70.0309 42.3043L68.8076 30.3043C68.6273 28.5363 70.0149 27 71.7921 27H104.176C105.944 27 107.328 28.5204 107.163 30.2802L106.037 42.2802Z",
    stroke: "white",
    strokeWidth: 6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.471 84H77.4707C73.6047 84 70.4707 87.134 70.4707 91C70.4707 94.866 73.6047 98 77.4707 98H100.471C104.337 98 107.471 94.866 107.471 91C107.471 87.134 104.337 84 100.471 84Z",
    stroke: "white",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsintheIcon);
export default __webpack_public_path__ + "static/media/absinthe-icon.1abb750f08c5a4e40285828d09c45d6d.svg";
export { ForwardRef as ReactComponent };